import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useMemo, useState } from 'react';
import { throttle } from 'throttle-debounce';
import { TABLE_THROTTLE_PERIOD } from '../constants';
import { LEFT, RIGHT } from '../../../constants';
import { getWindow } from '../../../system/util/globals';
import { useRootRef } from '../../../system';
export var useTable = function useTable(_ref, ref) {
  var stickyColumns = _ref.stickyColumns,
      stickyHead = _ref.stickyHead;
  var stickyColumnsInternal = useMemo(function () {
    var result = {};

    if (!stickyColumns) {
      return result;
    }

    var maxLeftOffset = 0;
    var maxRightOffset = 0;
    var leftEdgeItemIndex;
    var rightEdgeItemIndex;

    for (var i = 0; i < stickyColumns.length; i += 1) {
      var index = stickyColumns[i].index;

      var item = _objectSpread(_objectSpread({}, stickyColumns[i]), {}, {
        edge: false,
        offset: stickyColumns[i].offset || 0
      });

      if (item.alignment === LEFT && item.offset >= maxLeftOffset) {
        maxLeftOffset = item.offset;
        leftEdgeItemIndex = index;
      }

      if (item.alignment === RIGHT && item.offset >= maxRightOffset) {
        maxRightOffset = item.offset;
        rightEdgeItemIndex = index;
      }

      result = _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, index, item));
    }

    if (leftEdgeItemIndex !== undefined) {
      result[leftEdgeItemIndex].edge = true;
    }

    if (rightEdgeItemIndex !== undefined) {
      result[rightEdgeItemIndex].edge = true;
    }

    return result;
  }, [stickyColumns]);

  var _useState = useState({
    data: {
      stickyColumns: stickyColumnsInternal,
      stickyHead: stickyHead
    },
    update: function update(data) {
      return setTableContextValue(data);
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      tableContextValue = _useState2[0],
      setTableContextValue = _useState2[1];

  var rootReference = useRootRef(ref);
  var onLayoutUpdateImmediate = useCallback(function () {
    if (!stickyColumns || !stickyColumns.length) {
      return;
    }

    if (rootReference.current) {
      var scrollLeft = rootReference.current.scrollLeft;
      var node = rootReference.current;
      var firstChild = node.children[0];

      if (!firstChild) {
        return;
      }

      var tableWidth = node.getBoundingClientRect().width;
      var firstChildWidth = firstChild.getBoundingClientRect().width;
      var differentLevelsLeft = scrollLeft > 0;
      var differentLevelsRight = Math.ceil(tableWidth + scrollLeft) < Math.ceil(firstChildWidth);
      var _tableContextValue$da = tableContextValue.data,
          stickyLeftColumnVisible = _tableContextValue$da.stickyLeftColumnVisible,
          stickyRightColumnVisible = _tableContextValue$da.stickyRightColumnVisible;

      if (stickyRightColumnVisible !== differentLevelsRight || stickyLeftColumnVisible !== differentLevelsLeft) {
        setTableContextValue(_objectSpread(_objectSpread({}, tableContextValue), {}, {
          data: _objectSpread(_objectSpread({}, tableContextValue.data), {}, {
            stickyLeftColumnVisible: differentLevelsLeft,
            stickyRightColumnVisible: differentLevelsRight
          })
        }));
      }
    }
  }, []);
  var onLayoutUpdate = useCallback(throttle(TABLE_THROTTLE_PERIOD, false, onLayoutUpdateImmediate), [onLayoutUpdateImmediate]);
  useEffect(function () {
    onLayoutUpdateImmediate();
    var win = getWindow();

    if (win) {
      win.addEventListener('resize', onLayoutUpdate);
    }

    return function () {
      if (win) {
        win.removeEventListener('resize', onLayoutUpdate);
      }
    };
  }, []);
  return {
    tableContextValue: tableContextValue,
    rootReference: rootReference,
    onLayoutUpdate: onLayoutUpdate
  };
};